import {
  AbstractControl,
  FormArray,
  ValidationErrors,
  ValidatorFn
} from '@angular/forms';

export function validateFieldIsUniqueInFormArray(
  formArray: FormArray,
  fieldName?: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fieldsToCheck = formArray.controls.map((control) =>
      fieldName ? control.get(fieldName)?.value : control.value
    );

    return fieldsToCheck.filter((value) => value === control.value).length > 1
      ? { duplicate: true }
      : null;
  };
}
